import * as Sentry from '@sentry/vue'

const initActionLog = (store) => {
  // Subscribe action hooks
  try {
    if (store.subscribeAction) {
      store.subscribeAction({
        error: (action, state, error) => {
          Sentry.captureException(error, {
            // ref https://docs.sentry.io/platforms/javascript/enriching-events/fingerprinting/
            fingerprint: ['vuex-action', action?.type ?? 'unknown-action', '{{ default }}'], // group by action.type and stack trace
            extra: {
              action,
            },
          })
        },
      })
    }
  } catch (error) {
    // do nothing
  }
}

export default {
  initActionLog,
}
